import { FormControl, FormGroup } from '@angular/forms';

export function isFieldValid(form: FormGroup, field: string) {
  return !form.get(field).valid && form.get(field).touched;
}

export function displayFieldCss(form: FormGroup, field: string) {
  return {
    'has-error': this.isFieldValid(form, field),
    'has-feedback': this.isFieldValid(form, field),
  };
}

export function emailValidation(e): boolean {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (re.test(String(e).toLowerCase())) {
    return true;
  } else {
    return false;
  }
}

export function validateAllFormFields(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach((field) => {
    const control = formGroup.get(field);
    if (control instanceof FormControl) {
      control.markAsTouched({ onlySelf: true });
    } else if (control instanceof FormGroup) {
      this.validateAllFormFields(control);
    }
  });
}

export function textValidation(e): boolean {
  if (e) {
    return true;
  } else {
    return false;
  }
}

export function numberValidation(e): boolean {
  if (e && e >= 0) {
    return true;
  } else {
    return false;
  }
}

export function passwordValidation(e): boolean {
  // Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character
  var re = new RegExp(
    '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
  );
  if (re.test(String(e))) {
    return true;
  } else {
    return false;
  }
}

export function confirmPasswordValidation(e, password: string): boolean {
  if (password === String(e)) {
    return true;
  } else {
    return false;
  }
}
